import React from 'react';
import { graphql } from 'gatsby';
import SEO from 'components/SEO';
import H1 from 'components/H1';
import { Box, Flex, Container } from 'components/Grid';
import RichText from 'components/RichText';

const CookiesPage = ({ data }) => {
	const { title, text } = data.contentfulCookiePage;

	return (
		<div>
			<SEO title={title} keywords={[`gatsby`, `application`, `react`]} />
			<Container>
				<Flex justifyContent="center">
					<Box textAlign="center" width={[1, 3 / 4]}>
						<H1 color="client.primary">{title}</H1>
					</Box>
				</Flex>
				<Flex py={[4, 5]} justifyContent="center">
					<Box width={[1, 2 / 3]}>
						<RichText json={text.json} />
					</Box>
				</Flex>
			</Container>
		</div>
	);
};

export const pageQuery = graphql`
	query {
		contentfulCookiePage {
			title
			text {
				json
			}
		}
	}
`;

export default CookiesPage;
